import { IconButtonGroup } from "@cofano/cck";
import { AccessTime, Segment, Menu } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { intl } from "LocaleWrapper";

export enum DeclarationView {
	Time,
	List,
	Grouped
}

type DeclarationNavigationButtonProps = {
	active: DeclarationView;
	basePath?: string;
}

const DeclarationViewButtons = ({ active, basePath = "/view/declarations/purchase" }: DeclarationNavigationButtonProps) => {
	const navigate = useNavigate();

	return <IconButtonGroup
		items={[ {
			icon: <AccessTime fontSize="small" color={active == DeclarationView.Time ? "primary" : undefined} />,
			label: intl.formatMessage({ id: "CALCULATION_METHOD_TYPE_TIME_UNIT" }),
			onClick: () => navigate(basePath),
		}, {
			icon: <Menu fontSize="small" color={active == DeclarationView.List ? "primary" : undefined} />,
			label: intl.formatMessage({ id: "LIST" }),
			onClick: () => navigate(`${basePath}/list`),
		}, {
			icon: <Segment fontSize="small" color={active == DeclarationView.Grouped ? "primary" : undefined} />,
			label: intl.formatMessage({ id: "GROUPED" }),
			onClick: () => navigate(`${basePath}/grouped`),
		} ]} />;
};

export default DeclarationViewButtons;
